export enum ArchiveListTypes {
    SHOW_ARCHIVE_LIST_LOADING = "SHOW_ARCHIVE_LIST_LOADING",
    HIDE_ARCHIVE_LIST_LOADING = "HIDE_ARCHIVE_LIST_LOADING",
    REQUEST_LOAD_ARCHIVE_LIST = "REQUEST_LOAD_ARCHIVE_LIST",
    SET_ARCHIVE_LIST_DATA = "SET_ARCHIVE_LIST_DATA",
    SET_SEARCH_TEXT = "SET_SEARCH_TEXT"
}